import { render } from "./Paggo365FormDialog.vue?vue&type=template&id=44ea15b4&scoped=true"
import script from "./Paggo365FormDialog.vue?vue&type=script&lang=js"
export * from "./Paggo365FormDialog.vue?vue&type=script&lang=js"

import "./Paggo365FormDialog.vue?vue&type=style&index=0&id=44ea15b4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ea15b4"]])

export default __exports__